import { ErrorEvent, NumericEvent, OtherEvent } from '@/tracking/metrics/metrics.interfaces';
import { Event as StatsigEvent } from '@/tracking/statsig/types';

export function mapStatsigOther(event: OtherEvent) {
    const value = event.value || {};
    const metadata = event.metadata || {};

    return {
        eventName: event.type,
        value,
        metadata,
    } as StatsigEvent;
}

export function mapStatsigNumeric(event: NumericEvent) {
    const value = event.value || {};
    const metadata = event.metadata || {};
    metadata.value = event.value;

    return {
        eventName: event.type,
        value,
        metadata,
    } as StatsigEvent;
}

export function mapStatsigError(event: ErrorEvent) {
    const value = event.value || {};
    const metadata = event.metadata || {};
    metadata.error = event.error.message;

    return {
        eventName: event.type,
        value,
        metadata,
    } as StatsigEvent;
}
